import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/components/Home';
import Signature from '@/components/Signature';
import CreateAppleEmailSignature from '@/components/Create-Apple-Email-Signature';
import Projects from '@/components/Projects';
import Templates from '@/components/Templates';
import NotFound from '@/components/Not-Found';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Marketing Tools',
            component: Home
        },
        {
            path: '/signature',
            name: 'Signature',
            component: Signature
        },
        {
            path: '/create-apple-email-signature',
            name: 'Create HTML Signature in Apple Mail',
            component: CreateAppleEmailSignature
        },
        {
            path: '/projects',
            name: 'Projects',
            component: Projects
        },
        {
            path: '/templates',
            name: 'Templates',
            component: Templates
        },
        {
            path: '/404',
            component: NotFound
        }, {
            path: '*',
            redirect: '/404'
        },
    ]
});
